import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from '@/lang/en';
import cn from '@/lang/cn';

Vue.use(VueI18n);

export const languageList = {
  en: 'English',
  cn: '简体中文',
};

const localeMessages = {
  en,
  cn,
};

function setI18nLanguage(lang: string, i18n: VueI18n): string {
  i18n.locale = lang;
  return lang;
}

export function loadLanguageAsync(
  lang: string,
  i18n: VueI18n,
): Promise<string> {
  const localLang = lang;
  if (!localLang) {
    return Promise.reject();
  }
  if (i18n.locale !== localLang) {
    return Promise.resolve(setI18nLanguage(localLang, i18n));
  }
  return Promise.resolve(localLang);
}

export function createI18n(local: string): VueI18n {
  const localLang = local || 'en';

  const i18n = new VueI18n({
    silentTranslationWarn: true,
    locale: localLang,
    fallbackLocale: 'en',
    messages: localeMessages,
  });
  return i18n;
}
